import { render, staticRenderFns } from "./SerachInfo.vue?vue&type=template&id=edad94ec&scoped=true"
import script from "./SerachInfo.vue?vue&type=script&lang=js"
export * from "./SerachInfo.vue?vue&type=script&lang=js"
import style0 from "./SerachInfo.vue?vue&type=style&index=0&id=edad94ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edad94ec",
  null
  
)

export default component.exports